import {defineMessages} from "@project/i18n";

export const aiAssistantMessages = defineMessages({
  actionRequired: {
    id: "extensions.aiAssistant.actionRequired",
    defaultMessage: "Action required",
    description: "Label for assistant affordance when user action is required",
  },
  attachFile: {
    id: "extensions.aiAssistant.attachFile",
    defaultMessage: "Attach file",
    description: "Tooltip and accessible label for assistant attachment action",
  },
  attachmentMessage: {
    id: "extensions.aiAssistant.attachmentMessage",
    defaultMessage: "Attachment message",
    description: "Fallback first-line label for a user message with only attachments",
  },
  conversationNavigation: {
    id: "extensions.aiAssistant.conversationNavigation",
    defaultMessage: "Conversation navigation",
    description: "Accessible label for assistant conversation table of contents trigger",
  },
  copyMessage: {
    id: "extensions.aiAssistant.copyMessage",
    defaultMessage: "Copy message",
    description: "Tooltip and accessible label for copying a user message",
  },
  copyResponse: {
    id: "extensions.aiAssistant.copyResponse",
    defaultMessage: "Copy response",
    description: "Tooltip and accessible label for copying an assistant response",
  },
  downloadAttachments: {
    id: "extensions.aiAssistant.downloadAttachments",
    defaultMessage: "Download attachments",
    description: "Tooltip and accessible label for downloading message attachments",
  },
  editMessage: {
    id: "extensions.aiAssistant.editMessage",
    defaultMessage: "Edit message",
    description: "Tooltip, accessible label, and placeholder for editing a user message",
  },
  footerDisclaimer: {
    id: "extensions.aiAssistant.footerDisclaimer",
    defaultMessage: "AI can make mistakes. Check important info.",
    description: "Disclaimer shown below assistant prompt input",
  },
  label: {
    id: "extensions.aiAssistant.label",
    defaultMessage: "AI Assistant",
    description: "Label for assistant extension in sidebar and mobile switcher",
  },
  messages: {
    id: "extensions.aiAssistant.messages",
    defaultMessage: "Messages",
    description: "Heading for assistant conversation table of contents",
  },
  promptPlaceholder: {
    id: "extensions.aiAssistant.promptPlaceholder",
    defaultMessage: "Ask anything...",
    description: "Placeholder for assistant prompt text area",
  },
  removeAttachment: {
    id: "extensions.aiAssistant.removeAttachment",
    defaultMessage: "Remove attachment",
    description: "Accessible label for removing an attachment from assistant prompt",
  },
  scrollToBottom: {
    id: "extensions.aiAssistant.scrollToBottom",
    defaultMessage: "Scroll to bottom",
    description: "Accessible label and tooltip for scrolling to bottom of assistant conversation",
  },
  scrollToStreamingResponse: {
    id: "extensions.aiAssistant.scrollToStreamingResponse",
    defaultMessage: "Scroll to streaming response",
    description: "Accessible label for scrolling to currently streaming assistant response",
  },
  sendEditedMessage: {
    id: "extensions.aiAssistant.sendEditedMessage",
    defaultMessage: "Send",
    description: "Button label for submitting an edited user message",
  },
  sendMessage: {
    id: "extensions.aiAssistant.sendMessage",
    defaultMessage: "Send message",
    description: "Accessible label for sending assistant prompt",
  },
  stopGeneration: {
    id: "extensions.aiAssistant.stopGeneration",
    defaultMessage: "Stop generation",
    description: "Accessible label for stopping assistant response generation",
  },
  cancelEdit: {
    id: "extensions.aiAssistant.cancelEdit",
    defaultMessage: "Cancel",
    description: "Button label for cancelling user message editing",
  },
  tryAgain: {
    id: "extensions.aiAssistant.tryAgain",
    defaultMessage: "Try again",
    description: "Tooltip and accessible label for retrying an assistant response",
  },
  useVoice: {
    id: "extensions.aiAssistant.useVoice",
    defaultMessage: "Use voice",
    description: "Tooltip and accessible label for assistant voice action",
  },
});
